/**
 * Core Components
 * @author Lorenzo Girardi
 * @copyright (c) AQuest
 * @module base/common
 */

import { data } from './dom-utils';

export const sortByData = (unorderedEls) => {

    return unorderedEls.sort((a, b) => {

        const orderA = data('order', a);
        const orderB = data('order', b);

        if (orderA > orderB) {
            return 1;
        }

        if (orderB > orderA) {
            return -1;
        }

        if (orderA === orderB) {
            return 0;
        }
    });
};


/** WEBPACK FOOTER **
 ** ./base/utils.js
 **/